<template>
    <div class="">
        <el-row type="flex" justify="center" class="hidden-md-and-up">
            <el-col :xs="22">
                <el-row>
                    <el-col :xs="24">
                        <el-row type="flex" justify="center" class="h-menu-panel" >
                            <el-col :md="20" class="h-menu-title">
                                <div class="news-sub">PRODUCT</div>
                                <div class="news-title" >红米粒-急救培训</div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24">
                        <el-col :xs="8" v-for="(item,index) in list" :key="index" @click.native="selectType(index)" class="lists">
                            <div class="item">
                                 <span  :class="item.baner.icon" class="iconfont"></span>
                                 <span >{{item.baner.title}}</span>    
                            </div>
                        </el-col>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row style="height: 350px;margin-top: 20px;" type="flex" justify="center" class="hidden-md-and-up" >
            <el-col :xs="22" style="height: 100%;overflow: hidden;">
                <el-carousel height="350px" :autoplay="false">
                    <el-carousel-item  v-for="(item,index) in list[idx].products" :key="index">
                      <div class="phone-swiper">
                          <div class="top-img"  :style="{backgroundImage:'url('+item.proImg+')'}"></div>
                          <div class="content">
                              <div>{{item.id}}</div>
                              <div>{{item.title}}</div>
                          </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
            </el-col>
        </el-row>
                <el-row type="flex" class="hml-two hml-btm" justify="center" align="center">
                    <el-col :md="22" :xs="22">
                        <el-row>
                            <el-col :md="24">
                                <el-col :md="24" class="m-m-title">
                                    <div >AED</div>
                                    <div>{{$t('service.hml.aed.title')}}</div>
                                </el-col>
                            </el-col>
                            <el-col :md="24">
                                <el-row type="flex"  justify="center " class="hml-content" align="center">
                                    <el-col :md="22">
                                        <el-col :md="24" style="text-align: center;color: #f27c5e;font-size: 18px;">
                                            {{$t('service.hml.aed.subtitle')}}
                                        </el-col>
                                        <el-col :md="24" class="content">
                                            <el-row :gutter="10" type="flex" >
                                                <el-col :md="24" class="hidden-sm-and-down">
                                                    <div class="items" v-for="(item,index) in services.top" :key="index" >
                                                        <el-col :span="6" :xs="12" class="info" >
                                                            <div class="img-view">
                                                                <div class="img" :style="{backgroundImage:'url('+item.img+')'}"></div>
                                                            </div>
                                                        </el-col>
                                                        <el-col :span="6" :xs="12" class="info" >
                                                            <div class="img-view">
                                                                <div class="msg">{{$t('service.hml.aed.datas1')[index].title}}</div>
                                                            </div>
                                                        </el-col>
                                                    </div>
                                                    
                                                    <div class="items" v-for="(item,index) in services.btm" :key="index">
                                                        <el-col :span="6" :xs="12" class="info " >
                                                            <div class="img-view">
                                                            <div class="msg">{{$t('service.hml.aed.datas2')[index].title}}</div>
                                                            </div>
                                                        </el-col>
                                                        <el-col :span="6" :xs="12" class="info" >
                                                            <div class="img-view">
                                                                <div class="img" :style="{backgroundImage:'url('+item.img+')'}"></div>
                                                            </div>
                                                        </el-col>
                                                    </div>
                                                </el-col>
                                                <el-col :md="24" class="hidden-md-and-up">
                                                    <div class="items" v-for="(item,index) in services.top" :key="index" >
                                                        <div v-if="index % 2 == 0">
                                                            <el-col :span="6" :xs="12" class="info" >
                                                                <div class="img-view">
                                                                    <div class="img" :style="{backgroundImage:'url('+item.img+')'}"></div>
                                                                </div>
                                                            </el-col>
                                                            <el-col :span="6" :xs="12" class="info" >
                                                                <div class="img-view">
                                                                    <div class="msg">{{$t('service.hml.aed.datas1')[index].title}}</div>
                                                                </div>
                                                            </el-col>
                                                        </div>
                                                        <div v-else>
                                                            <el-col :span="6" :xs="12" class="info " >
                                                                <div class="img-view">
                                                                <div class="msg">{{$t('service.hml.aed.datas2')[index].title}}</div>
                                                                </div>
                                                            </el-col>
                                                            <el-col :span="6" :xs="12" class="info" >
                                                                <div class="img-view">
                                                                <div class="img" :style="{backgroundImage:'url('+item.img+')'}"></div>
                                                                </div>
                                                            </el-col>
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="items" v-for="(item,index) in services.btm" :key="index">
                                                        <div v-if="index % 2 == 0">
                                                            <el-col :span="6" :xs="12" class="info" >
                                                                <div class="img-view">
                                                                <div class="img" :style="{backgroundImage:'url('+item.img+')'}"></div>
                                                                </div>
                                                            </el-col>
                                                            <el-col :span="6" :xs="12" class="info" >
                                                                <div class="img-view">
                                                                <div class="msg">{{$t('service.hml.aed.datas1')[index].title}}</div>
                                                                </div>
                                                            </el-col>
                                                        </div>
                                                        <div v-else>
                                                            <el-col :span="6" :xs="12" class="info " >
                                                                <div class="img-view">
                                                                <div class="msg">{{$t('service.hml.aed.datas2')[index].title}}</div>
                                                                </div>
                                                            </el-col>
                                                            <el-col :span="6" :xs="12" class="info" >
                                                                <div class="img-view">
                                                                <div class="img" :style="{backgroundImage:'url('+item.img+')'}"></div>
                                                                </div>
                                                            </el-col>
                                                        </div>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        
                    </el-col>
                </el-row>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    // import hmlSwiper from '../moduleSwiper/hmlSwiper.vue';
    export default{
        props:['list'],
        name:'myHml',
        data() {
            return{
                
                products:[
                    {
                     bgImg:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/ser-pro-01.png',
                     products:[
                         {id:1,img:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/ser-pro-bg.png'}
                        ]  
                    }
                ],
                services:{
                    top:[
                        {id:1,title:'上门急救培训',img:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/hml/peix.jpg'},
                        {id:1,title:'AED装备定制',img:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/hml/sheb.jpg'}
                    ],
                    btm:[
                        {id:1,title:'专业的评估咨询',img:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/hml/zix.jpg'},
                        {id:1,title:'国际证书',img:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/hml/zhengs.jpg'},
                    ]
                },
                serList:[
                        {id:1,title:'上门急救培训',img:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/hml/peix.jpg'},
                        {id:2,title:'AED装备定制',img:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/hml/sheb.jpg'},
                        {id:3,title:'专业的评估咨询',img:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/hml/zix.jpg'},
                        {id:4,title:'国际证书',img:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/hml/zhengs.jpg'}
                ],
                searchData:[
                    {id:1,data:'30+',unit:'年',msg:'益生菌领域研究'},
                    {id:1,data:'258+',unit:'项',msg:'临床研究'},
                    {id:1,data:'21279',unit:'名',msg:'研究对象'},
                    {id:1,data:'194',unit:'篇',msg:'科技论文发布'},
                    {id:1,data:'100+',unit:'个',msg:'国家/地区在售'},
                    {id:1,data:'10+',unit:'个',msg:'国际指南推荐'}
                ],
                searchFinds:[
                    {
                        title:"肠绞痛随访",
                        datas:[
                            {id:1,data:'82',msg:'跟踪服务',unit:'人'},
                            {id:1,data:'64',msg:'完成21天随访服务',unit:'人'},
                            {id:1,data:'73.4%',msg:'第7天成功治疗率',unit:''},
                            {id:1,data:'81.3%',msg:'第14天成功治疗率',unit:''},
                            {id:1,data:'93.8%',msg:'第21天成功治疗率',unit:''},
                        ]
                    },
                    {
                        title:"肠胀气随访",
                        datas:[
                            {id:1,data:'43',msg:'跟踪服务',unit:'人'},
                            {id:1,data:'36',msg:'完成21天随访服务',unit:'人'},
                            {id:1,data:'24.9%',msg:'第7天严重程度减少',unit:''},
                            {id:1,data:'52.9%',msg:'第14天严重程度减少',unit:''},
                            {id:1,data:'60.3%',msg:'第21天严重程度减少',unit:''},
                        ]
                    },
                    {
                        title:"肠道训练营",
                        datas:[
                            {id:1,data:'1',unit:'人',msg:'跟踪服务'},
                            {id:1,data:'7',unit:'人',msg:'完成21天随访服务'},
                            {id:1,data:'7',unit:'份',msg:'真实评价'},
                        ],
                    },
                    {
                        title:"口腔训练营",
                        datas:[
                            {id:1,data:'242',unit:'人',msg:'跟踪服务'},
                            {id:1,data:'178',unit:'人',msg:'完成30天随访服务'},
                            {id:1,data:'119',unit:'份',msg:'真实评价'},
                        ]
                    }
                ],
                idx:0,
                windowWidth:window.innerWidth,
            }
        },
        computed:{
          currentIdx(){
              return this.mySwiperMainIndex
          },
          
        },
        mounted() {
             
        },
        
        methods:{
            selectType(index){
                this.idx = index
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/mh.scss';
 $title-panel-sub:#acacac;
    $title-panel-sub_opacity:.2;
    $title-panel-title:#443530;
    $title-panel-title_size:18px;
    $content-font:14px;
    .el-carousel__item{
         border: 1px solid rgba(0, 0, 0, .1);
         border-radius: 10px;
    }
    /deep/ .el-carousel__indicator--horizontal .el-carousel__button {
        width: 10px;
        height: 10px;
        background: transparent;
        border: 1px solid #959595;
        border-radius: 50%;
        opacity: 0.5;
      }  
      /deep/ .el-carousel__indicator--horizontal.is-active .el-carousel__button{
        width: 10px;
        height: 10px;
        background: #959595;
        border-radius: 50%;
        opacity: 1;
      }
    .phone-swiper{
        display: flex;
        flex-direction: column;
       
        .top-img{
            width: 100%;
            height: 250px;
            background-size: cover;
            background-position: center;
        }
        .content{
            margin-top: 10px;
            font-size: 22px;
            display: flex;
            flex-direction: row;
            height: 50px;
            align-items: center;
            div{
                &:first-child{
                    padding: 0 20px;
                    border-right: 2px solid #dedede;
                }
                &:last-child{
                    padding: 0 20px;
                }
            }
        }
    }
    .iconfont{
        color: #000;
    }
    .lists{
        padding: 2px;
        .item{
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid rgba(0, 0, 0, .05);
            border-radius: 5px;
            padding: 2px 0;
            span:last-child{
                font-size: 18px;
                font-weight: 550;
                margin-left: 5px;
            }
            .iconfont{
            }
        }
        .active{
            background-color: #BA4D48;
            color: #FFF;
        }
        
    }
    .hml-btm{
        .hml-content{
            flex-direction: column;align-items: center;
            .content{
                overflow: hidden;
                margin-top: 20px;
                .items{
                    
                    &:hover{
                        .img{
                            transform:scale(1.2);
                        }
                        .msg{
                            transform:scale(1.2);
                        }
                    }
                }
                .info{
                     
                    .img-view{
                        height: 100%;
                        width: 100%;
                        overflow: hidden;
                        .img{
                            height: 100%;
                            width: 100%;
                            background-position: center;
                            background-size: cover;
                            transition: all 0.5s ease-in-out; 
                        }
                        .msg{
                            width: 100%;
                            height: 100%;
                            display: flex;
                            background-color: #f27c5e;
                            justify-content: center;
                            align-items: center;
                            color: #FFF;
                            transition: all 0.5s ease-in-out; 
                        }
                    }
                    
                   & > div{
                       border-radius: 10px;
                   }
                   @media only screen and (max-width:920px){
                       height: 150px;
                   }
                    height: 250px;padding-top: 10px;
                    
                    align-items: center;
                    display: flex;
                    justify-content: center;
                    
                }
                
            }
        }
    }
    .tow-main{
        .right{
            background-image: url('https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/hml/hml-gy.jpg');
            background-size: cover;
            height: 400px;
        }
        .left{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 400px;
            .content{
                div:first-child{
                    text-indent: 30px;
                    margin-bottom: 30px;
                    padding: 5px;
                }
                font-size: $h-font-16;
                height: 100%;
                line-height: 28px;
            }
            .btn{
                padding: 0;
                text-align: left;
                p{
                    padding:0 5px;
                    font-size: $title-panel-title_size;
                    color: $title-panel-title;
                    font-weight: bold;
                    
                }
                .btns{
                   
                    display: flex;
                    flex-wrap: wrap;
                    .el-button{
                        border: none;
                        margin: 5px;
                        width: 45%;
                    }
                }
            }
        }
    }
    .title-module{
        position: relative;
        text-align: center;
        .title-sub{
            color: $title-panel-sub;
            opacity: $title-panel-sub_opacity;
            font-size: 40px;
            letter-spacing: 3px;
        }
        p{
            font-weight: bold;
            
        }
        .title{
            position: relative;
            top: -50px;
            font-weight: bold;
            font-size:$title-panel-title_size ;
            color: $title-panel-title;
        }
    }
    .hml-two{
        @media only screen and (min-width:920px){
            height: 100vh;
        }
        flex-direction: column;
        align-items: center;
    }
    .menu{
        letter-spacing: 3px;
        width: 100%;
        position: absolute;
        z-index: 99;
        bottom: 0;
        .item{
            transition: background .4s ease-in-out;
            padding: 15px 0;
            &+.item{
                border-left: 1px solid #acacac;
            }
        }
        .active{
            background-color: #BA4D48;
            color: #FFF;
        }
        .bactive{
            background-color: #209e8b;
            color: #FFF;
        }
        .lose{
            background-color: #FFF;
            color: #000
        }
    }
    .page-top{
        height: 100vh;
        width: 100vw;
        position: relative;
        align-items: center;
        .page-title{
            height: 100vh;
            align-items: center;
            display: flex;
            
        }
        h1{
            color: #fff;
            font-weight: bold;
        }
        h6{
            &+h6{
               border-top: 1px solid #acacac; 
               letter-spacing: 3px;
            }
            color: #fff;
            padding: 20px 0;
        }
    }
    
    .my-swiper{
        height: var(--h);
        width: var(--w);
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        .parallax-bg{
            position: absolute;
            left: 0;
            top: 0;
            width: 130%;
            height: 100%;
            -webkit-background-size: cover;
            background-size: 100% 100%;
            background-position: center;
        }
    }
</style>